export default __webpack_public_path__ + "static/side-left-ffdb8e483a0ba5d24927dbf42e9cf081.jpg";